import Swiper from "swiper";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

let swiperInstance;

function initializeSwiper() {
  return new Swiper(".swiper", {
    loop: false,
    slidesPerView: 1,
    grabCursor: false,
    spaceBetween: 16,
    pagination: {
      el: ".swiper-pagination--services",
      clickable: true,
    },
    modules: [Pagination],
  });
}

function toggleSwiperClassesAndInstance() {
  const swiperContainer = document.querySelector(".js-swiper");
  const swiperWrapper = document.querySelector(".js-swiper-wrapper");
  const swiperSlides = document.querySelectorAll(".js-swiper-slide");

  if (swiperContainer) {
    if (window.innerWidth < 992) {
      swiperContainer.classList.add("swiper");
      swiperWrapper.classList.add("swiper-wrapper");
      swiperWrapper.classList.remove("services-content");
      swiperSlides.forEach((slide) => slide.classList.add("swiper-slide"));

      if (!swiperInstance) {
        swiperInstance = initializeSwiper();
      }
    } else {
      swiperContainer.classList.remove("swiper");
      swiperWrapper.classList.remove("swiper-wrapper");
      swiperWrapper.classList.add("services-content");
      swiperSlides.forEach((slide) => slide.classList.remove("swiper-slide"));

      if (swiperInstance) {
        swiperInstance.destroy();
        swiperInstance = null;
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  toggleSwiperClassesAndInstance();

  window.addEventListener("resize", toggleSwiperClassesAndInstance);
});
